import { getCmsRoutesAction } from "../../../Actions/LogicActions/Search/GetCmsRoutesActions";
import { populateSearchForCmsAction } from "../../../Actions/UIActions/Search/PopulateSearchForCmsAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { IPopulateSearchForCmsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/IPopulateSearchForCmsActionParams";

export class RoutesStep extends StepFlow {
  get stepName() { return "RoutesStep"; }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on({
        eventName: evtTree.Routes.Get,
        handler: async () => {
          getCmsRoutesAction.execute();
        }
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IPopulateSearchForCmsActionParams, void>({
        eventName: evtTree.Routes.Card.Click,
        handler: async ({ data }) => {
          populateSearchForCmsAction.setParams(data!);
          await populateSearchForCmsAction.execute();
        }
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("RoutesStep Init Step Execute...");

    _eventBus.emit({
      eventName: evtTree.Routes.Get,
    });
  }
}
export const routesStepDeclaration = new StepDefinition({
  stepName: "RoutesStep",
  stepClass: RoutesStep
});
